import request from "../../utils/request";
export default {
  getCustomerInfo: function getCustomerInfo() {
    return request('get', 'api/crm/v1/onlinebranch/getcustomerinfo');
  },
  getFaqs: function getFaqs() {
    return request('get', 'api/crm/v1/onlinebranch/faqs');
  },
  getBankInfos: function getBankInfos() {
    return request('get', 'api/crm/v1/onlinebranch/bankinfos');
  },
  getBranchInfos: function getBranchInfos() {
    return request('get', 'api/crm/v1/onlinebranch/branchinfos');
  },
  setGdprStatus: function setGdprStatus() {
    return request('post', 'api/crm/v1/onlinebranch/setcustomergdprstatus');
  },
  getGdprStatus: function getGdprStatus() {
    return request('get', 'api/crm/v1/onlinebranch/getcustomergdprstatusbypartyid');
  },
  handleSatisfactionSurvey: function handleSatisfactionSurvey(model, requiredAreas) {
    return request('post', 'api/crm/v1/onlinebranch/satisfactionsurvey?initial=' + requiredAreas, model);
  },
  verifyEmail: function verifyEmail(code) {
    return request('post', "api/crm/v1/onlinebranch/verifyEmail/", code);
  } // getCity() { // onlinebranch city
  //   return request('get', 'api/crm/v1/onlinebranch/branchinfos')
  // }
  // getDistrict() { // onlinebranch distrcit
  //   return request('get', 'api/crm/v1/onlinebranch/branchinfos')
  // }
  // preregister() { // onlinebranch preregister
  //   return request('get', 'api/crm/v1/onlinebranch/branchinfos')
  // }
};